import React from 'react';
import './PressRedesign.css';

import logoWhite from '../../../images/logo-white.png';
import mediaImage from '../../../images/editpage-dashboard-item.png';
import templateOneDark from '../../../images/marketing/Template1-dark.png';
import templateTwoDark from '../../../images/marketing/Template2-dark.png';

const pressFacts = [
  {
    label: 'Product focus',
    value: 'Simple, guided website creation and publishing',
  },
  {
    label: 'Primary audience',
    value: 'Creators, founders, and small business teams',
  },
  {
    label: 'Operating model',
    value: 'Remote-friendly team serving customers globally',
  },
];

const coveragePoints = [
  'EditPage delivers a practical editor focused on speed, clarity, and ease of use.',
  'The platform helps customers launch quickly with fewer technical barriers.',
  'Website, domain, hosting, and growth tools work together in one connected workflow.',
];

const PressContent = ({ history }) => {
  const openSignup = () => {
    if (history && history.push) {
      history.push('/signup');
      return;
    }
    window.location.href = '/signup';
  };

  return (
    <div className="press-redesign">
      <section className="press-hero">
        <div className="press-wrap">
          <p className="press-eyebrow">Media & press</p>
          <h1>EditPage Press</h1>
          <p>
            Looking for official information about EditPage? This page includes
            product background, company facts, and media contact paths.
          </p>
          <button type="button" onClick={openSignup}>Start Building</button>
        </div>
      </section>

      <section className="press-main">
        <div className="press-wrap">
          <article className="press-story-card">
            <div className="press-story-copy">
              <h2>Press materials</h2>
              <p>
                EditPage is designed to make professional website publishing accessible.
                The core experience prioritizes speed, intuitive controls, and
                straightforward publishing from first setup to launch.
              </p>
              <ul>
                {coveragePoints.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="press-story-media">
              <img src={mediaImage} alt="EditPage interface preview" />
            </div>
          </article>

          <article className="press-facts">
            <div className="press-facts-header">
              <img src={logoWhite} alt="EditPage" />
              <h2>Quick facts</h2>
            </div>
            <div className="press-facts-grid">
              {pressFacts.map((item) => (
                <div className="press-fact" key={item.label}>
                  <h3>{item.label}</h3>
                  <p>{item.value}</p>
                </div>
              ))}
            </div>
          </article>

          <article className="press-assets">
            <div>
              <h2>Media assets</h2>
              <p>
                For articles, interviews, and product coverage, request our current
                brand marks, product visuals, and approved messaging references.
              </p>
              <a href="/contact">Request full press kit -&gt;</a>
            </div>
            <div className="press-assets-grid">
              <img src={templateOneDark} alt="EditPage product visual one" />
              <img src={templateTwoDark} alt="EditPage product visual two" />
            </div>
          </article>

          <section className="press-contact">
            <h2>Want to talk to us?</h2>
            <p>
              For interviews, quotes, and brand requests, please <a href="/contact">contact us</a>.
              You can also reach us on <a href="http://www.facebook.com/editpagehq">Facebook</a>
              {' '}and <a href="http://www.twitter.com/editpagehq">Twitter</a>.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
};

export default PressContent;
